module.exports = __webpack_public_path__ + "img/Arif-Medianto@3x.d0fa51d5.png";